import React from 'react';
import styles from '../Flecks.module.scss';
import { RGBData } from '../../../../types/colours';
import { getFleckPosition } from '../../../../helpers/fleck';

export interface FlecksProps {
	color: RGBData;
	index: number;
}

const Fleck: React.FC<FlecksProps> = ({ color, index }) => (
	<div
		className={styles.fleck}
		style={{
			backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b})`,
			animationDirection: index % 2 === 0 ? 'normal' : 'reverse',
			animationDelay: `${index * 0.01}s`,
			...getFleckPosition(index),
		}}
	/>
);

export default Fleck;
